export class FpsCounter {
    constructor(elementId = 'fpsCounter', updateInterval = 1000) {
        this.element = document.getElementById(elementId);
        if (!this.element) {
            this.element = document.createElement('div');
            this.element.id = elementId;
            this.element.textContent = 'FPS: 0';
            this.element.style.position = 'fixed';
            this.element.style.top = '10px';
            this.element.style.left = '10px';
            this.element.style.zIndex = '9999';
            this.element.style.padding = '10px';
            this.element.style.fontSize = '16px';
            this.element.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
            this.element.style.color = 'white';
            this.element.style.border = 'none';
            this.element.style.borderRadius = '5px';
            document.body.appendChild(this.element);
        }
        this.frameCount = 0;
        this.lastUpdateTime = performance.now();
        this.updateInterval = updateInterval;
        this.currentFps = 0;
        this.isActive = true; // Flag pour éviter les calculs quand inactif
    }
    
    update() {
        if (!this.isActive) return;
        
        this.frameCount++;
        
        const currentTime = performance.now();
        const deltaTime = currentTime - this.lastUpdateTime;
        
        if (deltaTime >= this.updateInterval) {
            // Éviter les divisions par zéro et les valeurs aberrantes
            if (deltaTime > 0 && this.frameCount > 0) {
                this.currentFps = (this.frameCount / deltaTime) * 1000;
                
                // Limiter les valeurs aberrantes
                this.currentFps = Math.min(this.currentFps, 240); // Max 240 FPS
                
                if (this.element) {
                    this.element.textContent = `FPS: ${this.currentFps.toFixed(1)}`;
                }
            }
            
            this.frameCount = 0;
            this.lastUpdateTime = currentTime;
        }
    }
    
    getFps() {
        return this.currentFps;
    }
      reset() {
        this.frameCount = 0;
        this.lastUpdateTime = performance.now();
        this.currentFps = 0;
        
        if (this.element) {
            this.element.textContent = 'FPS: 0.0';
        }
    }
    
    pause() {
        this.isActive = false;
    }
    
    resume() {
        this.isActive = true;
        this.reset(); // Reset pour éviter des calculs erronés après pause
    }
}
